import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class PaisesService extends Service{

  protected url: string = this.dominio+"/adm/paises/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/paises/paises.service.ts